import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable } from "rxjs"
import { TeacherClassSubjectMappingCreateRequestDTO, TeacherClassSubjectMappingDTO, TeacherClassSubjectMappingUpdateRequestDTO, TeacherClassSubjectMappingList, TeacherClassSubjectMappingDeleteRequestDTO, TeacherClassSubjectMappingReadByIdRequestDTO, TeacherClassSubjectMappingReadByClassIdRequestDTO, TeacherClassSubjectMappingReadBySchoolIdRequestDTO, TeacherClassSubjectMappingReadBySubjectIdRequestDTO, TeacherClassSubjectMappingReadByTeacherIdRequestDTO } from "./teacher-class-subject-mapping.interface"
import { TeacherClassSubjectMapping_Create, TeacherClassSubjectMapping_Update, TeacherClassSubjectMapping_ReadAll, TeacherClassSubjectMapping_Delete, TeacherClassSubjectMapping_ReadById, TeacherClassSubjectMapping_ReadBySchoolId, TeacherClassSubjectMapping_ReadByClassId, TeacherClassSubjectMapping_ReadBySubjectId, TeacherClassSubjectMapping_ReadByTeacherId } from "src/app/GlobalVariable"

@Injectable({
    providedIn: 'root'
})
export class TeacherClassSubjectMappingService {

    constructor() { }

    http = inject(HttpClient)


    TeacherClassSubjectMapping_Create(data: TeacherClassSubjectMappingCreateRequestDTO): Observable<TeacherClassSubjectMappingDTO> {
        return this.http.post<TeacherClassSubjectMappingDTO>(TeacherClassSubjectMapping_Create, data)
    }

    TeacherClassSubjectMapping_Update(data: TeacherClassSubjectMappingUpdateRequestDTO): Observable<TeacherClassSubjectMappingDTO> {
        return this.http.post<TeacherClassSubjectMappingDTO>(TeacherClassSubjectMapping_Update, data)
    }

    TeacherClassSubjectMapping_ReadAll(): Observable<TeacherClassSubjectMappingList> {
        return this.http.get<TeacherClassSubjectMappingList>(TeacherClassSubjectMapping_ReadAll)
    }
    TeacherClassSubjectMapping_Delete(data: TeacherClassSubjectMappingDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(TeacherClassSubjectMapping_Delete, data)
    }


    TeacherClassSubjectMapping_ReadById(data: TeacherClassSubjectMappingReadByIdRequestDTO): Observable<TeacherClassSubjectMappingDTO> {
        return this.http.post<TeacherClassSubjectMappingDTO>(TeacherClassSubjectMapping_ReadById, data)
    }
    TeacherClassSubjectMapping_ReadByTeacherId(data: TeacherClassSubjectMappingReadByTeacherIdRequestDTO): Observable<TeacherClassSubjectMappingList> {
        return this.http.post<TeacherClassSubjectMappingList>(TeacherClassSubjectMapping_ReadByTeacherId, data)
    }

    TeacherClassSubjectMapping_ReadBySchoolId(data: TeacherClassSubjectMappingReadBySchoolIdRequestDTO): Observable<TeacherClassSubjectMappingList> {
        return this.http.post<TeacherClassSubjectMappingList>(TeacherClassSubjectMapping_ReadBySchoolId, data)
    }

    TeacherClassSubjectMapping_ReadByClassId(data: TeacherClassSubjectMappingReadByClassIdRequestDTO): Observable<TeacherClassSubjectMappingList> {
        return this.http.post<TeacherClassSubjectMappingList>(TeacherClassSubjectMapping_ReadByClassId, data)
    }
    TeacherClassSubjectMapping_ReadBySubjectId(data: TeacherClassSubjectMappingReadBySubjectIdRequestDTO): Observable<TeacherClassSubjectMappingList> {
        return this.http.post<TeacherClassSubjectMappingList>(TeacherClassSubjectMapping_ReadBySubjectId, data)
    }


}
